import React, { createContext, useState, useContext, useCallback } from 'react';

type IUserContext = {
  userData: string;
  setUserData: ((data: string) => void) | undefined;
  isAuthenticated: boolean; // 認証状態を管理（ページ表示制御用）
  setIsAuthenticated: ((authenticated: boolean) => void) | undefined; // 認証状態設定関数
}

const defaultContext:IUserContext ={
  userData: '',
  setUserData: () => {},
  isAuthenticated: false, // 初期状態は未認証
  setIsAuthenticated: () => {} // 認証状態設定関数のデフォルト
}

export const UserContext = createContext<IUserContext>(defaultContext);

export function useUserContext() {
  return useContext(UserContext);
}

const useUserData = (): IUserContext => {
  // state名はThemeContext typeのプロパティに合わせる。
  const [userData, setUserDataState] = useState<string>('');
  const [isAuthenticated, setIsAuthenticatedState] = useState<boolean>(false); // 認証状態管理

  // 関数名はThemeContext typeのプロパティに合わせる。
  const setUserData = useCallback((current: string): void => {
    setUserDataState(current);
  }, []);

  // 認証状態を設定する関数（ページ表示制御用）
  const setIsAuthenticated = useCallback((authenticated: boolean): void => {
    setIsAuthenticatedState(authenticated);
  }, []);
  
  return {
    userData,
    setUserData,
    isAuthenticated, // 認証状態を返す
    setIsAuthenticated // 認証状態設定関数を返す
  };
}

interface Props  {
  children?: React.ReactNode;
}

export const UserProvider: React.FC<Props> = ({children}) => {
    const userCtx = useUserData();

    return (
        <>
            {/* 子コンポーネントの描画 */}
            <UserContext.Provider value={userCtx}>{children}</UserContext.Provider>
        </>
    );
};
